import { Card, CardContent, CardHeader, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PoolIcon from '@mui/icons-material/Pool';

const MuiDashboardLeaveSummary = () => {

    return (

        <Card sx={{ height: 300 }}>
            <CardHeader
                subheader="İzin durumları"
                avatar={<PoolIcon />}
                action=
                {
                    <Tooltip title="İzin detayları">
                        <IconButton>
                            <MoreHorizIcon />
                        </IconButton>
                    </Tooltip>
                }
            />

            <CardContent>
                <Stack spacing={2}>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Typography>Onay bekleyen </Typography>
                        <Typography variant="h3" color="red" > 4 talep</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Typography>Kalan yıllık izin toplamı </Typography>
                        <Typography variant="h3">155 gün</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        <Typography>Fazla mesai izin toplamı </Typography>
                        <Typography variant="h3">30 saat</Typography>
                    </Stack>

                </Stack>

            </CardContent>

        </Card>
    )
}

export default MuiDashboardLeaveSummary